<script setup>
const props = defineProps({
  pointInfo: {
    type: Object,
    default: () => ({})
  },
  riverName: {
    type: String,
    default: ''
  }
})

useCustomMeta('obs', props.pointInfo.Name, '', props.pointInfo.RiverNm)
const { $isWebViewFlag: isWebViewFlag } = useNuxtApp()
const breadCrumbList = isWebViewFlag ? [] : getBreadCrumb('point', props.riverName, props.pointInfo.Name)
const { data: detailData } = await useAsyncData(
  `riverDetailData-${props.pointInfo.ID}`,
  () => $fetch('https://aplapi.weathernews.jp/lba/river/api_observatory_detail', {
    query: {
      observatory_id: props.pointInfo.ID
    }
  }),
  { watch: [() => props.pointInfo.ID] }
)
watch(() => detailData.value, () => {
  window.scrollTo({ top: 0, behavior: 'instant' })
})
</script>

<template>
  <div>
    <NuxtLayout
      name="custom"
      :bread-crumb-list="breadCrumbList"
    >
      <div class="frame">
        <div class="head">
          <p class="tag">
            {{ makeInfo(props.pointInfo) }}
          </p>
          <CommonPageTitle :title="props.pointInfo.Name" />
        </div>
      </div>
      <template #main-bottom>
        <RiverWaterLevelContent
          :detail-data="detailData"
        />
        <HorizontalStackAd
          v-if="!isWebViewFlag"
          left-ad-id="ads-btf2-left-pc"
          right-ad-id="ads-btf2-right-pc"
        />
        <div
          id="ads-btf1-sp"
          class="ads-btf1-sp"
        />
        <RiverAroundList
          :id="props.pointInfo.ID"
          :title="props.pointInfo.Name"
          :lat="props.pointInfo.Lat"
          :lon="props.pointInfo.Lon"
        />
        <TopicList />
      </template>
    </NuxtLayout>
  </div>
</template>

<style lang="scss" scoped>
.frame {
  display: flex;
  flex-direction: column;
  gap: 10px;
  .head {
    display: flex;
    flex-direction: column;
    gap: 5px;
    align-items: flex-start;
  }
  .tag {
    padding: 6px 10px;
    border-radius: 4px;
    background-color: #EEF1F8;
    color: #606060;
    font-size: 10px;
    font-weight: 600;
    line-height: 1em;
    letter-spacing: .25px;
  }
}
.ads-btf1-sp {
  min-height: 50px;
  text-align: center;
  margin: 0px auto;
  position: relative;
}
</style>
